/*  ========================================================================
    # Landingpage - Quotes - Index
    ========================================================================  */

import React from 'react';
import { createRoot } from 'react-dom/client';
import Quotes from './Quotes';

const containers = document.querySelectorAll('div[data-react-app="quotes"]');

for (let i = 0; i < containers.length; i++) {
  const propsAttribute = containers[i].attributes['data-react-props']?.value || '{}';
  const props = JSON.parse(propsAttribute) || {};

  createRoot(containers[i]).render(<Quotes {...props} />);
}
